// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}

/*!
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * Similar as inputBorder but without active styles.
 */
/**
 * Create a consistent border for an input element.
 * With Nextcloud 32+ there is no real border anymore but we use a box-shadow.
 */
body {
  /**
   * Set custom vue-select CSS variables.
   * Needs to be on the body (not :root) for theming to apply (see nextcloud/server#36462)
   */
  /* Search Input */
  --vs-search-input-color: var(--color-main-text);
  --vs-search-input-bg: var(--color-main-background);
  --vs-search-input-placeholder-color: var(--color-text-maxcontrast);
  /* Font */
  --vs-font-size: var(--default-font-size);
  --vs-line-height: var(--default-line-height);
  /* Disabled State */
  --vs-state-disabled-bg: var(--color-background-hover);
  --vs-state-disabled-color: var(--color-text-maxcontrast);
  --vs-state-disabled-controls-color: var(--color-text-maxcontrast);
  --vs-state-disabled-cursor: not-allowed;
  --vs-disabled-bg: var(--color-background-hover);
  --vs-disabled-color: var(--color-text-maxcontrast);
  --vs-disabled-cursor: not-allowed;
  /* Borders */
  --vs-border-color: var(--color-border-maxcontrast);
  --vs-border-width: var(--border-width-input, 2px) !important;
  --vs-border-style: solid;
  --vs-border-radius: var(--border-radius-element);
  /* Component Controls: Clear, Open Indicator */
  --vs-controls-color: var(--color-main-text);
  /* Selected */
  --vs-selected-bg: var(--color-background-hover);
  --vs-selected-color: var(--color-main-text);
  --vs-selected-border-color: var(--vs-border-color);
  --vs-selected-border-style: var(--vs-border-style);
  --vs-selected-border-width: var(--vs-border-width);
  /* Dropdown */
  --vs-dropdown-bg: var(--color-main-background);
  --vs-dropdown-color: var(--color-main-text);
  --vs-dropdown-z-index: 9999;
  --vs-dropdown-box-shadow: 0px 2px 2px 0px var(--color-box-shadow);
  /* Options */
  --vs-dropdown-option-padding: 8px 20px;
  /* Active State */
  --vs-dropdown-option--active-bg: var(--color-background-hover);
  --vs-dropdown-option--active-color: var(--color-main-text);
  /* Keyboard Focus State */
  --vs-dropdown-option--kb-focus-box-shadow: inset 0px 0px 0px 2px var(--vs-border-color);
  /* Deselect State */
  --vs-dropdown-option--deselect-bg: var(--color-error);
  --vs-dropdown-option--deselect-color: #fff;
  /* Transitions */
  --vs-transition-duration: 0ms;
  /* Actions */
  --vs-actions-padding: 0 8px 0 4px;
}
.v-select.select {
  /* Override default vue-select styles */
  min-height: calc(var(--default-clickable-area) - 2 * var(--border-width-input));
  min-width: 260px;
  margin: 0 0 var(--default-grid-baseline);
}
.v-select.select.vs--open {
  --vs-border-width: var(--border-width-input-focused, 2px);
}
.v-select.select .select__label {
  display: block;
  margin-bottom: 2px;
}
.v-select.select .vs__selected {
  height: calc(var(--default-clickable-area) - 2 * var(--vs-border-width) - var(--default-grid-baseline));
  margin: calc(var(--default-grid-baseline) / 2);
  padding-block: 0;
  padding-inline: 12px 8px;
  border-radius: 16px !important;
  background: var(--color-primary-element-light);
  border: none;
}
.v-select.select.vs--open .vs__selected:first-of-type {
  margin-inline-start: calc(var(--default-grid-baseline) / 2 - (var(--border-width-input-focused, 2px) - var(--border-width-input, 2px))) !important;
}
.v-select.select .vs__search {
  text-overflow: ellipsis;
  color: var(--color-main-text);
  min-height: unset !important;
  height: calc(var(--default-clickable-area) - 2 * var(--vs-border-width)) !important;
}
.v-select.select .vs__search::placeholder {
  color: var(--color-text-maxcontrast);
}
.v-select.select .vs__search, .v-select.select .vs__search:focus {
  margin: 0;
}
.v-select.select .vs__dropdown-toggle {
  position: relative;
  max-height: 100px;
  padding: var(--border-width-input);
  overflow-y: auto;
}
.v-select.select .vs__actions {
  position: sticky;
  top: 0;
}
.v-select.select .vs__clear {
  margin-inline-end: 2px;
}
.v-select.select.vs--open .vs__dropdown-toggle {
  border-color: var(--color-main-text);
  border-bottom-color: transparent;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-style: solid;
  border-width: var(--border-width-input-focused);
  outline: 2px solid var(--color-main-background);
  padding: 0;
}
.v-select.select:not(.vs--disabled, .vs--open) .vs__dropdown-toggle:active,
.v-select.select:not(.vs--disabled, .vs--open) .vs__dropdown-toggle:focus-within {
  outline: 2px solid var(--color-main-background);
  border-color: var(--color-main-text);
}
.v-select.select.vs--disabled .vs__search,
.v-select.select.vs--disabled .vs__selected {
  color: var(--color-text-maxcontrast);
}
.v-select.select.vs--disabled .vs__clear,
.v-select.select.vs--disabled .vs__deselect {
  display: none;
}
.v-select.select--no-wrap .vs__selected-options {
  flex-wrap: nowrap;
  overflow: auto;
  min-width: unset;
}
.v-select.select--no-wrap .vs__selected-options .vs__selected {
  min-width: unset;
}
.v-select.select--drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 var(--vs-border-radius) var(--vs-border-radius);
  border-top-color: transparent;
  border-bottom-color: var(--color-main-text);
}
.v-select.select .vs__selected-options {
  min-height: calc(var(--default-clickable-area) - 2 * var(--vs-border-width));
}
.v-select.select .vs__selected-options .vs__selected ~ .vs__search[readonly] {
  position: absolute;
}
.v-select.select .vs__selected-options {
  padding: 0 5px;
}
.v-select.select.vs--single.vs--loading .vs__selected, .v-select.select.vs--single.vs--open .vs__selected {
  max-width: 100%;
  opacity: 1;
  color: var(--color-text-maxcontrast);
}
.v-select.select.vs--single .vs__selected-options {
  flex-wrap: nowrap;
}
.v-select.select.vs--single .vs__selected {
  background: unset !important;
}
.vs__dropdown-toggle {
  --input-border-box-shadow-light: 0 -1px var(--vs-border-color),
  	0 0 0 1px color-mix(in srgb, var(--vs-border-color), 65% transparent);
  --input-border-box-shadow-dark: 0 1px var(--vs-border-color),
  	0 0 0 1px color-mix(in srgb, var(--vs-border-color), 65% transparent);
  --input-border-box-shadow: var(--input-border-box-shadow-light);
  border: none;
  border-radius: var(--border-radius-element);
  box-shadow: var(--input-border-box-shadow);
}
.vs__dropdown-toggle:hover:not([disabled]) {
  box-shadow: 0 0 0 1px var(--vs-border-color);
}
@media (prefers-color-scheme: dark) {
.vs__dropdown-toggle .vs__dropdown-toggle {
    --input-border-box-shadow: var(--input-border-box-shadow-dark);
}
}
[data-theme-dark] .vs__dropdown-toggle {
  --input-border-box-shadow: var(--input-border-box-shadow-dark);
}
[data-theme-light] .vs__dropdown-toggle {
  --input-border-box-shadow: var(--input-border-box-shadow-light);
}
.select--legacy .vs__dropdown-toggle {
  box-shadow: 0 0 0 1px var(--vs-border-color);
}
.select--legacy .vs__dropdown-toggle:hover:not([disabled]) {
  box-shadow: 0 0 0 2px var(--vs-border-color);
}
.vs__dropdown-menu {
  border-width: var(--border-width-input-focused) !important;
  border-color: var(--color-main-text) !important;
  outline: none !important;
  box-shadow: -2px 0 0 var(--color-main-background), 0 2px 0 var(--color-main-background), 2px 0 0 var(--color-main-background), !important;
  padding: 4px !important;
}
.vs__dropdown-menu--floating {
  /* Fallback styles overidden by programmatically set inline styles */
  width: max-content;
  position: absolute;
  top: 0;
  inset-inline-start: 0;
}
.vs__dropdown-menu--floating-placement-top {
  border-radius: var(--vs-border-radius) var(--vs-border-radius) 0 0 !important;
  border-top-style: var(--vs-border-style) !important;
  border-bottom-style: none !important;
  box-shadow: 0 -2px 0 var(--color-main-background), -2px 0 0 var(--color-main-background), 2px 0 0 var(--color-main-background), !important;
}
.vs__dropdown-menu .vs__dropdown-option {
  border-radius: 6px !important;
}
.vs__dropdown-menu .vs__no-options {
  color: var(--color-text-maxcontrast) !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/dialogs/node_modules/@nextcloud/vue/dist/assets/NcSelect-CvDEQAjD.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;EAGE;AACF;;EAEE;AACF;;;EAGE;AACF;EACE;;;IAGE;EACF,iBAAiB;EACjB,+CAA+C;EAC/C,kDAAkD;EAClD,kEAAkE;EAClE,SAAS;EACT,wCAAwC;EACxC,4CAA4C;EAC5C,mBAAmB;EACnB,qDAAqD;EACrD,wDAAwD;EACxD,iEAAiE;EACjE,uCAAuC;EACvC,+CAA+C;EAC/C,kDAAkD;EAClD,iCAAiC;EACjC,YAAY;EACZ,kDAAkD;EAClD,4DAA4D;EAC5D,wBAAwB;EACxB,gDAAgD;EAChD,8CAA8C;EAC9C,2CAA2C;EAC3C,aAAa;EACb,+CAA+C;EAC/C,2CAA2C;EAC3C,kDAAkD;EAClD,kDAAkD;EAClD,kDAAkD;EAClD,aAAa;EACb,8CAA8C;EAC9C,2CAA2C;EAC3C,2BAA2B;EAC3B,iEAAiE;EACjE,YAAY;EACZ,sCAAsC;EACtC,iBAAiB;EACjB,8DAA8D;EAC9D,0DAA0D;EAC1D,yBAAyB;EACzB,uFAAuF;EACvF,mBAAmB;EACnB,qDAAqD;EACrD,0CAA0C;EAC1C,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,uCAAuC;EACvC,+EAA+E;EAC/E,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,uGAAuG;EACvG,8CAA8C;EAC9C,gBAAgB;EAChB,wBAAwB;EACxB,8BAA8B;EAC9B,8CAA8C;EAC9C,YAAY;AACd;AACA;EACE,kJAAkJ;AACpJ;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,mFAAmF;AACrF;AACA;EACE,oCAAoC;AACtC;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,MAAM;AACR;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;EAC7B,mBAAmB;EACnB,+CAA+C;EAC/C,+CAA+C;EAC/C,UAAU;AACZ;AACA;;EAEE,+CAA+C;EAC/C,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kEAAkE;EAClE,6BAA6B;EAC7B,2CAA2C;AAC7C;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,UAAU;EACV,oCAAoC;AACtC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE;wEACsE;EACtE;wEACsE;EACtE,+DAA+D;EAC/D,YAAY;EACZ,2CAA2C;EAC3C,0CAA0C;AAC5C;AACA;EACE,4CAA4C;AAC9C;AACA;AACA;IACI,8DAA8D;AAClE;AACA;AACA;EACE,8DAA8D;AAChE;AACA;EACE,+DAA+D;AACjE;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,0DAA0D;EAC1D,+CAA+C;EAC/C,wBAAwB;EACxB,yIAAyI;EACzI,uBAAuB;AACzB;AACA;EACE,oEAAoE;EACpE,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,qBAAqB;AACvB;AACA;EACE,6EAA6E;EAC7E,mDAAmD;EACnD,oCAAoC;EACpC,0IAA0I;AAC5I;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,+CAA+C;AACjD","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n\n/*!\n * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * Similar as inputBorder but without active styles.\n */\n/**\n * Create a consistent border for an input element.\n * With Nextcloud 32+ there is no real border anymore but we use a box-shadow.\n */\nbody {\n  /**\n   * Set custom vue-select CSS variables.\n   * Needs to be on the body (not :root) for theming to apply (see nextcloud/server#36462)\n   */\n  /* Search Input */\n  --vs-search-input-color: var(--color-main-text);\n  --vs-search-input-bg: var(--color-main-background);\n  --vs-search-input-placeholder-color: var(--color-text-maxcontrast);\n  /* Font */\n  --vs-font-size: var(--default-font-size);\n  --vs-line-height: var(--default-line-height);\n  /* Disabled State */\n  --vs-state-disabled-bg: var(--color-background-hover);\n  --vs-state-disabled-color: var(--color-text-maxcontrast);\n  --vs-state-disabled-controls-color: var(--color-text-maxcontrast);\n  --vs-state-disabled-cursor: not-allowed;\n  --vs-disabled-bg: var(--color-background-hover);\n  --vs-disabled-color: var(--color-text-maxcontrast);\n  --vs-disabled-cursor: not-allowed;\n  /* Borders */\n  --vs-border-color: var(--color-border-maxcontrast);\n  --vs-border-width: var(--border-width-input, 2px) !important;\n  --vs-border-style: solid;\n  --vs-border-radius: var(--border-radius-element);\n  /* Component Controls: Clear, Open Indicator */\n  --vs-controls-color: var(--color-main-text);\n  /* Selected */\n  --vs-selected-bg: var(--color-background-hover);\n  --vs-selected-color: var(--color-main-text);\n  --vs-selected-border-color: var(--vs-border-color);\n  --vs-selected-border-style: var(--vs-border-style);\n  --vs-selected-border-width: var(--vs-border-width);\n  /* Dropdown */\n  --vs-dropdown-bg: var(--color-main-background);\n  --vs-dropdown-color: var(--color-main-text);\n  --vs-dropdown-z-index: 9999;\n  --vs-dropdown-box-shadow: 0px 2px 2px 0px var(--color-box-shadow);\n  /* Options */\n  --vs-dropdown-option-padding: 8px 20px;\n  /* Active State */\n  --vs-dropdown-option--active-bg: var(--color-background-hover);\n  --vs-dropdown-option--active-color: var(--color-main-text);\n  /* Keyboard Focus State */\n  --vs-dropdown-option--kb-focus-box-shadow: inset 0px 0px 0px 2px var(--vs-border-color);\n  /* Deselect State */\n  --vs-dropdown-option--deselect-bg: var(--color-error);\n  --vs-dropdown-option--deselect-color: #fff;\n  /* Transitions */\n  --vs-transition-duration: 0ms;\n  /* Actions */\n  --vs-actions-padding: 0 8px 0 4px;\n}\n.v-select.select {\n  /* Override default vue-select styles */\n  min-height: calc(var(--default-clickable-area) - 2 * var(--border-width-input));\n  min-width: 260px;\n  margin: 0 0 var(--default-grid-baseline);\n}\n.v-select.select.vs--open {\n  --vs-border-width: var(--border-width-input-focused, 2px);\n}\n.v-select.select .select__label {\n  display: block;\n  margin-bottom: 2px;\n}\n.v-select.select .vs__selected {\n  height: calc(var(--default-clickable-area) - 2 * var(--vs-border-width) - var(--default-grid-baseline));\n  margin: calc(var(--default-grid-baseline) / 2);\n  padding-block: 0;\n  padding-inline: 12px 8px;\n  border-radius: 16px !important;\n  background: var(--color-primary-element-light);\n  border: none;\n}\n.v-select.select.vs--open .vs__selected:first-of-type {\n  margin-inline-start: calc(var(--default-grid-baseline) / 2 - (var(--border-width-input-focused, 2px) - var(--border-width-input, 2px))) !important;\n}\n.v-select.select .vs__search {\n  text-overflow: ellipsis;\n  color: var(--color-main-text);\n  min-height: unset !important;\n  height: calc(var(--default-clickable-area) - 2 * var(--vs-border-width)) !important;\n}\n.v-select.select .vs__search::placeholder {\n  color: var(--color-text-maxcontrast);\n}\n.v-select.select .vs__search, .v-select.select .vs__search:focus {\n  margin: 0;\n}\n.v-select.select .vs__dropdown-toggle {\n  position: relative;\n  max-height: 100px;\n  padding: var(--border-width-input);\n  overflow-y: auto;\n}\n.v-select.select .vs__actions {\n  position: sticky;\n  top: 0;\n}\n.v-select.select .vs__clear {\n  margin-inline-end: 2px;\n}\n.v-select.select.vs--open .vs__dropdown-toggle {\n  border-color: var(--color-main-text);\n  border-bottom-color: transparent;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  border-style: solid;\n  border-width: var(--border-width-input-focused);\n  outline: 2px solid var(--color-main-background);\n  padding: 0;\n}\n.v-select.select:not(.vs--disabled, .vs--open) .vs__dropdown-toggle:active,\n.v-select.select:not(.vs--disabled, .vs--open) .vs__dropdown-toggle:focus-within {\n  outline: 2px solid var(--color-main-background);\n  border-color: var(--color-main-text);\n}\n.v-select.select.vs--disabled .vs__search,\n.v-select.select.vs--disabled .vs__selected {\n  color: var(--color-text-maxcontrast);\n}\n.v-select.select.vs--disabled .vs__clear,\n.v-select.select.vs--disabled .vs__deselect {\n  display: none;\n}\n.v-select.select--no-wrap .vs__selected-options {\n  flex-wrap: nowrap;\n  overflow: auto;\n  min-width: unset;\n}\n.v-select.select--no-wrap .vs__selected-options .vs__selected {\n  min-width: unset;\n}\n.v-select.select--drop-up.vs--open .vs__dropdown-toggle {\n  border-radius: 0 0 var(--vs-border-radius) var(--vs-border-radius);\n  border-top-color: transparent;\n  border-bottom-color: var(--color-main-text);\n}\n.v-select.select .vs__selected-options {\n  min-height: calc(var(--default-clickable-area) - 2 * var(--vs-border-width));\n}\n.v-select.select .vs__selected-options .vs__selected ~ .vs__search[readonly] {\n  position: absolute;\n}\n.v-select.select .vs__selected-options {\n  padding: 0 5px;\n}\n.v-select.select.vs--single.vs--loading .vs__selected, .v-select.select.vs--single.vs--open .vs__selected {\n  max-width: 100%;\n  opacity: 1;\n  color: var(--color-text-maxcontrast);\n}\n.v-select.select.vs--single .vs__selected-options {\n  flex-wrap: nowrap;\n}\n.v-select.select.vs--single .vs__selected {\n  background: unset !important;\n}\n.vs__dropdown-toggle {\n  --input-border-box-shadow-light: 0 -1px var(--vs-border-color),\n  \t0 0 0 1px color-mix(in srgb, var(--vs-border-color), 65% transparent);\n  --input-border-box-shadow-dark: 0 1px var(--vs-border-color),\n  \t0 0 0 1px color-mix(in srgb, var(--vs-border-color), 65% transparent);\n  --input-border-box-shadow: var(--input-border-box-shadow-light);\n  border: none;\n  border-radius: var(--border-radius-element);\n  box-shadow: var(--input-border-box-shadow);\n}\n.vs__dropdown-toggle:hover:not([disabled]) {\n  box-shadow: 0 0 0 1px var(--vs-border-color);\n}\n@media (prefers-color-scheme: dark) {\n.vs__dropdown-toggle .vs__dropdown-toggle {\n    --input-border-box-shadow: var(--input-border-box-shadow-dark);\n}\n}\n[data-theme-dark] .vs__dropdown-toggle {\n  --input-border-box-shadow: var(--input-border-box-shadow-dark);\n}\n[data-theme-light] .vs__dropdown-toggle {\n  --input-border-box-shadow: var(--input-border-box-shadow-light);\n}\n.select--legacy .vs__dropdown-toggle {\n  box-shadow: 0 0 0 1px var(--vs-border-color);\n}\n.select--legacy .vs__dropdown-toggle:hover:not([disabled]) {\n  box-shadow: 0 0 0 2px var(--vs-border-color);\n}\n.vs__dropdown-menu {\n  border-width: var(--border-width-input-focused) !important;\n  border-color: var(--color-main-text) !important;\n  outline: none !important;\n  box-shadow: -2px 0 0 var(--color-main-background), 0 2px 0 var(--color-main-background), 2px 0 0 var(--color-main-background), !important;\n  padding: 4px !important;\n}\n.vs__dropdown-menu--floating {\n  /* Fallback styles overidden by programmatically set inline styles */\n  width: max-content;\n  position: absolute;\n  top: 0;\n  inset-inline-start: 0;\n}\n.vs__dropdown-menu--floating-placement-top {\n  border-radius: var(--vs-border-radius) var(--vs-border-radius) 0 0 !important;\n  border-top-style: var(--vs-border-style) !important;\n  border-bottom-style: none !important;\n  box-shadow: 0 -2px 0 var(--color-main-background), -2px 0 0 var(--color-main-background), 2px 0 0 var(--color-main-background), !important;\n}\n.vs__dropdown-menu .vs__dropdown-option {\n  border-radius: 6px !important;\n}\n.vs__dropdown-menu .vs__no-options {\n  color: var(--color-text-maxcontrast) !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
